module.exports = __webpack_public_path__ + "img/locations_small.cc27fc33.png";